import React from 'react';
import Square from './Square';
import ButtonSquare from './ButtonSquare';

class Grid extends React.Component {
    renderSquares() {
      const rows = this.props.view.length;
      const cols = this.props.view[0].length;
      const viewIter = this.props.viewIter;
      const iteration = this.props.iteration;
  
      let gridList = [];
  
      for (let i=0; i<rows; i++) {
        let rowList = []
        let buttonsIndex = Math.min(viewIter-1, rows-1);
  
        // condition for making a button row
        if (((viewIter == iteration)) && (i == buttonsIndex)) {
          // insert a row of buttons
          for (let j=0; j<cols; j++) {
            rowList.push(
              <ButtonSquare
                key={(i*10 + j).toString()}
                alive={this.props.view[i][j]}
                onClick={() => this.props.onClick(j)}
              />
            );
          }
        } else {
          // make non-clickable square row
          for (let j=0; j<cols; j++) {
            rowList.push(
              <Square
                key={(i*10 + j).toString()}
                alive={this.props.view[i][j]}
              />
            );
          }
        }
  
        gridList.push(<div className="row">{rowList}</div>);
      }
  
      return (gridList);
    }
  
    render() {
      return (this.renderSquares());
    }
  }


export default Grid